import { jsx } from 'react/jsx-runtime';
import { memo, forwardRef } from 'react';
import { Wrap, WrapPadding } from './Container.styles.mjs';
"use strict";
const Container = memo(forwardRef(function Container2({
  children,
  noPaddings,
  noVerticalMargin,
  withExtraMargin,
  fullHeight,
  ...rest
}, ref) {
  return /* @__PURE__ */jsx(Wrap, {
    $noPaddings: noPaddings,
    $noVerticalMargin: noVerticalMargin,
    $withExtraMargin: withExtraMargin,
    $size: rest.size,
    ...rest,
    children: /* @__PURE__ */jsx(WrapPadding, {
      $fullHeight: fullHeight,
      ref,
      children
    })
  });
}));
export { Container };
//# sourceMappingURL=Container.mjs.map
